<template>
    <div class="container">
      <div class="header">
       <div :class="$vssWidth > 1000 ? 'sidenav' : 'sidenav2'">
          <a @click="menuPrincipal()">
            <i class="fas fa-bars icone_svg"></i>
          </a>
       </div>
        <div class="logo">
          <router-link to="/">
            <img src="https://firebasestorage.googleapis.com/v0/b/loja-ilha-teste.appspot.com/o/assets%2Flogo.webp?alt=media&token=e0c2d07f-8025-43ab-9ec6-40da8496bf16" alt="Ilha do Caranguejo" />
          </router-link>
        </div>

        <div class="header-icones">
          <div v-if="$store.state.usuario.usuario == null && $store.state.configuracoes.isLoginView === false" class="header-usuario">
            <a @click="minhaConta()" title="Acesse sua conta ou faça seu cadastro">
              <i class="fas fa-user-circle icone_svg margin"></i>
            </a>
          </div>

          <div v-else-if="$store.state.configuracoes.isLoginView === false" class="header-usuario2">
            <a @click="minhaConta()" title="Acesse sua conta">
              <i class="fas fa-user-circle icone_svg margin"></i>
              <span class="header-usuario-nome">{{$store.state.usuario.usuario.PrimeiroNome}}</span>
            </a>
          </div>

          <div v-if="$vssWidth > 1000">
            <a @click="handleOpenMenu" class="carrinho">
              <i class="fas fa-shopping-bag icone_svg"></i>
              <span v-if="contador > 0">{{contador}}</span>
            </a>
          </div>

          <div v-else>
            <a @click="abrirCarrinho()" class="carrinho">
              <i class="fas fa-shopping-bag icone_svg"></i>
              <span v-if="contador > 0">{{contador}}</span>
            </a>
          </div>

        </div>
      </div>

     </div>
</template>

<script>
import SidenavResponsivo from '@/components/SidenavResponsivo.vue'
import { mapActions, mapGetters } from 'vuex'
import VueScreenSize from 'vue-screen-size'

export default {
  name: 'Header',
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    SidenavResponsivo
  },
  computed: {
    ...mapGetters('carrinho', {
      contador: 'contadorProdutos'
    })
  },
  methods: {
    ...mapActions('menu', ['toggleMenu']),
    handleOpenMenu (e) {
      if (this.$store.state.carrinho.idCarrinho != null) {
        e.preventDefault()
        e.stopPropagation()
        this.toggleMenu(!this.$store.state.menu.aberto)
      }
    },
    ...mapActions('configuracoes', ['cadastroView']),
    minhaConta () {
      this.cadastroView(false)
      if (this.$store.state.usuario.usuario != null) {
        this.$router.push({name: 'Minha Conta'})
      } else {
        this.$router.push({name: 'Login'})
      }
    },
    abrirCarrinho () {
      this.limparFinalizacaoPedido()
      this.$router.push({name: 'Carrinho Footer'})
    },
    ...mapActions('menu', ['finalizacaoPedido', 'toggleMenu']),
    limparFinalizacaoPedido () {
      this.finalizacaoPedido(false)
      this.toggleMenu(false)
    },
    menuPrincipal () {
      this.$router.push({name: 'Menu'})
    }
  }
}
</script>

<style scoped>
.container {
  grid-area: header;
  background: #fff;
  width: 100%;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
}
.header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: space-between;
  align-items: center;
  max-width: 1600px;
  margin: 0 auto;
  flex-wrap: wrap;
  width: 100%;
  padding: 8px 0;
}

.sidenav {
  justify-self: start;
  margin: 0 0 0 25%;
}

.sidenav2 {
  justify-self: start;
  margin: 0 0 0 10px;
}

.logo {
  max-width: 130px;
  justify-self: center;
}

.header-icones {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.header a {
  margin: 0 20px 0 0;
  color: #2E9189;
}

.header a:hover {
  color: #F85E28;
}

.icone_svg {
  width: 30px;
  height: 30px;
}

.carrinho {
  display: flex;
}

.carrinho span {
  font-weight: 600;
  padding: 10px 8px;
}

.header-usuario {
  display: flex;
  align-content: center;
}

.header-usuario span{
  margin: 0 0 0 6px;
}

.header-usuario2 span{
  margin: 0 0 0 6px;
}

.header-usuario a {
  margin: 0 0 0 30px;
  color: #2E9189;
  display: flex;
  align-items: center;
}

.header-usuario2 a {
  margin: 0 0 0 30px;
  color: #F85E28;
  display: flex;
  align-items: center;
}

.header-usuario-nome {
  color: #F85E28;
}

@media (max-width: 960px) {
  .header-usuario-nome {
    display: none;
  }
  .header-icones {
    justify-content: flex-end;
  }
  .logo {
    max-width: 100px;
    margin-top: 5px
  }
  .icone_svg {
    width: 27px;
    height: 27px;
  }
  .margin {
    margin: 0 20px 0 0;
  }
  .carrinho span {
    font-weight: 600;
    padding: 5px 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue